const { get, post, put, del } = require("network/http/api")

export const companyDashboard = () => {
  return get(`/dashboard`)
}
